'use client';

import { calculateAverageEntryPrice } from '@velocity-exchange/common';
import type { ParentOrderInfo } from 'src/@types/historyTables';

interface AvgFillPriceCellProps {
	order: ParentOrderInfo;
}

export function AvgFillPriceCell({ order }: AvgFillPriceCellProps) {
	const { baseAssetAmountFilled, quoteAssetAmountFilled } = order;

	if (baseAssetAmountFilled.eqZero()) {
		return <span className="text-text-tertiary">-</span>;
	}

	const avgPriceBn = calculateAverageEntryPrice(
		quoteAssetAmountFilled,
		baseAssetAmountFilled
	);

	return avgPriceBn.toNotional(true);
}
